// The old cockpit's gauge, its dial shading from D-EDGE purple to D-EDGE teal. public/favicon.svg is the
// same drawing with a fixed dark grey needle; here the needle follows the theme.
const SEGMENTS: [path: string, colour: string][] = [
  ['M3.88 25A14 14 0 0 1 2.54 14.14L7.35 15.52A9 9 0 0 0 8.21 22.5Z', '#5B2D8E'],
  ['M2.84 13.21A14 14 0 0 1 9.86 5.42L12.05 9.91A9 9 0 0 0 7.54 14.92Z', '#4B4A98'],
  ['M10.76 5.02A14 14 0 0 1 21.24 5.02L19.37 9.66A9 9 0 0 0 12.63 9.66Z', '#2886A7'],
  ['M22.14 5.42A14 14 0 0 1 29.16 13.21L24.46 14.92A9 9 0 0 0 19.95 9.91Z', '#14A2AB'],
  ['M29.46 14.14A14 14 0 0 1 28.12 25L23.79 22.5A9 9 0 0 0 24.65 15.52Z', '#00B5AD'],
]

/** Decorative: it always sits next to the app name. */
export function BrandLogo({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden>
      {SEGMENTS.map(([path, colour]) => (
        <path key={colour} d={path} fill={colour} />
      ))}
      <path d="M14.97 16.77L24.43 10.93L17.03 19.23Z" fill="var(--text-main)" />
      <circle cx="16" cy="18" r="2.6" fill="var(--text-main)" />
    </svg>
  )
}
